import { Box, styled } from '@mui/material';
import { fadeInUp } from '../../utils/animation';

type AnimatedBoxProps = {
  delay?: string;
  backgroundColor?: string;
};

export const AnimatedBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'delay' && prop !== 'backgroundColor',
})<AnimatedBoxProps>(({ delay = '0s', backgroundColor }) => ({
  animation: `${fadeInUp} 0.4s ease forwards`,
  animationDelay: delay,
  opacity: 0,
  backgroundColor,
}));
